module.exports = (__parcel__import__("cbu2h")).then(() => parcelRequire('fyWP3'));